export const EXPERIMENT_FORM_LABEL_CLASS = "mb-2 block text-base font-bold tracking-tight text-foreground";
